export type PhoneMaskKind = 'landline' | 'mobile' | 'either';

/** Máscara brasileira: fixo (11) 3333-4444 ou celular (11) 98888-7777. */
export function formatPhoneMask(
  value: string | null | undefined,
  kind: PhoneMaskKind = 'either',
): string {
  let digits = (value ?? '').replace(/\D/g, '');
  if (digits.startsWith('55') && digits.length > 11) {
    digits = digits.slice(2);
  }

  const maxDigits = kind === 'landline' ? 10 : 11;
  digits = digits.slice(0, maxDigits);
  if (digits.length === 0) {
    return '';
  }

  const ddd = digits.slice(0, 2);
  if (digits.length <= 2) {
    return `(${ddd}`;
  }

  const subscriber = digits.slice(2);
  const useMobileShape = kind === 'mobile' || (kind === 'either' && digits.length > 10);
  const subscriberLength = useMobileShape ? 5 : 4;
  if (subscriber.length <= subscriberLength) {
    return `(${ddd}) ${subscriber}`;
  }

  return `(${ddd}) ${subscriber.slice(0, subscriberLength)}-${subscriber.slice(subscriberLength)}`;
}
